import add from "date-fns/add";
import sub from "date-fns/sub";
import { DatePickerDate } from "../../types";

export const canMoveToPreviousMonth = (activeDate: Date, minDate: DatePickerDate | undefined) => {
    if (!minDate) {
        return true;
    }

    const prevMonthDate = sub(activeDate, { months: 1 });

    return prevMonthDate.getFullYear() >= activeDate.getFullYear();
};

export const canMoveToNextMonth = (activeDate: Date, maxDate: DatePickerDate | undefined) => {
    if (!maxDate) {
        return true;
    }

    const nextMonthDate = add(activeDate, { months: 1 });

    return nextMonthDate.getFullYear() <= activeDate.getFullYear();
};
